// Recovered compiled webpack factory 63354. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { r: () => s });
  var n = i(51118);
  function s(t, e) {
    let i = t?.[e] ?? t?.default ?? t;
    return i !== t ? (0, n.K)(i, t) : i;
  }
}
